module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C381"
  }, [_c('em', [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Preface")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "C385"
  }, [_vm._v("This long-contemplated further volume of "), _c('em', [_vm._v("Studies")]), _vm._v(" has been delayed mainly by uncertainty about whether I ought to include the various essays preparatory to my inquiry on "), _c('em', [_vm._v("Law, Legislation and Liberty")]), _vm._v(" which for years I doubted my ability to complete. Much the greater part of what I published during the last 10 years were preliminary studies for that work which had little importance once the chief conclusions had found their final form in that systematic exposition. With two volumes published and the third near completion I feel now sufficiently confident to leave most of those earlier attempts dispersed as they are and have only included in this volume two or three of them which seem to me still to provide additional material.")]), _vm._v(" "), _c('p', {
    staticClass: "C384"
  }, [_vm._v("On the whole the present volume thus deals again equally with problems of philosophy, politics and economics, though it proved to be a little more difficult to decide to which category some of the essays belonged. Some readers may feel that some of the essays in the part on philosophy deal more with psychological than with strictly philosophical problems and that the part on economics now deals chiefly with what as an academic subject used to be called ‘money and banking’. The only difference in formal arrangement from the first volume is that I have thought it appropriate to give the kind of articles which in the earlier volume I had placed in an appendix the status of a fourth part under the heading ‘History of Ideas’ and to amend the title of the volume accordingly.")])]), _c('p', {
    staticClass: "C386"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Of the articles contained in this volume the lectures on ‘The Errors of Constructivism’ (")]), _c('a', {
    attrs: {
      "href": "#/html/07_Chapter_1__The_Errors_of_Constru#page_3"
    }
  }, [_vm._v("chapter 1")]), _vm._v(") and ‘Competition as a Discovery Procedure’ ("), _c('span', {
    attrs: {
      "href": "#/html/20_Chapter_12__Competition_as_a_Dis#page_179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 12")]), _vm._v(") have been published before only in German, while the article on ‘Liberalism’ ("), _c('span', {
    attrs: {
      "href": "#/html/16_Chapter_9__Liberalism#page_119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 9")]), _vm._v(") was written in English to be published in an Italian translation in the "), _c('em', [_vm._v("Enciclopedia del Novicento")]), _vm._v(" by the Istituto della Enciclopedia Italiana at Rome. To them as well as to all the other publishers of the original versions named in the footnotes at the beginning of each chapter I am greatly indebted for permission to reprint.")]), _vm._v(" "), _c('p', {
    staticClass: "C390"
  }, [_vm._v("F. A. HAYEK")]), _vm._v(" "), _c('p', {
    staticClass: "C356"
  }, [_vm._v("Freiburg i.B.")]), _vm._v(" "), _c('p', {
    staticClass: "C356"
  }, [_vm._v("April 1977")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-553cfeb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/05_Preface.vue
// module id = 69
// module chunks = 0